import { Inject, Injectable } from '@angular/core';
import { API_URL } from '../../app-store-providers';
import { HttpClient } from '@angular/common/http';
import { Dictionary } from '../../../shared/models/dictionary';
import { EntityTypes } from '../../entity/entity-types';
import { StoreBaseService } from '../../common/base.service';

@Injectable({
  providedIn: 'root'
})
export class DictionaryTagService
  extends StoreBaseService<Dictionary> {

  get entityType(): string {
    return EntityTypes.tag;
  }

  get resourceName(): string {
    return 'tag';
  }

  constructor(
    @Inject(API_URL) apiUrl: string,
    http: HttpClient
  ) {
    super(apiUrl, http);
  }
}
